import { render, staticRenderFns } from "./PostFormOfferType.vue?vue&type=template&id=027fadeb&"
import script from "./PostFormOfferType.vue?vue&type=script&lang=js&"
export * from "./PostFormOfferType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports